// extracted by mini-css-extract-plugin
export var actionButton = "_x5-2";
export var card = "_x5-0";
export var errorCard = "_x5-3";
export var row = "_x5-1";